import { Alert, Col, Row } from 'reactstrap';
import DataTable from "components/Core/DataTable";
import { useRef, useMemo } from "react";

const HistorySKUDetails = (props) => {
  const {data} = props;
  const table = useRef(null);
  const dollar = useMemo(() => Intl.NumberFormat('en-US', {
    style: "currency",
    currency: "USD",
	}),[]);
  const headers = [
    {title: 'date', data: 'date', searchable: true, sortable: true},
    {title: 'product Name', data: 'productName', searchable: true, sortable: true},
    {title: 'supplier Name', data: 'supplierName', searchable: true, sortable: true},
    {title: 'face Value', data: 'faceValue', searchable: true, sortable: true},
    {title: 'Qty', data: 'totalQuantity', searchable: true, sortable: true},
    {title: 'fee', data: 'fee', sortable: true, render: data => data ? data : 0},
    {title: 'discount', data: 'discount', sortable: true},
    {title: 'Amount', data: 'totalAmount', sortable: true, render: data => data ? dollar.format(data) : 0},
  ]
  return (
    <>
      <Row className="justify-content-between m-4">
        <Col>
          <div className="details">
            <h4>Summary</h4>
            <DataTable
              options={{
                searching: false,
                responsive: true,
                info: false,
                dom: "tip" 
              }}
              ref={table}
              data={data.purchaseOrderDetails}
              columns={headers}
            />
          </div>
        </Col>
      </Row>
      <Row className="justify-content-end m-5">
        <Col sm="4" className="mr-4">
          <Alert color="success">
            <Row className="justify-content-between">
              <Col sm="3">Total</Col>
              <Col sm="9">
                <p className="p-0 m-0 text-right">{dollar.format(data.totalAmount)}</p>
              </Col>
            </Row>
          </Alert>
        </Col>
      </Row>
    </>
  );
};

export default HistorySKUDetails;
